import { InputLabel, MenuItem, Select, OutlinedInput } from "@mui/material"
import { Fragment } from "react"
import { uid } from "uid"

function SelectInput({ id, isError, label, fontWeight, options = [], renderValueKey, selectLabel, varianttype, ref, MenuProps, ...rest }) {
  id = id || uid(6)

  return (
    <Fragment>
      {label &&
        <InputLabel
          htmlFor={id}
          sx={{
            mb: 0.25,
            fontSize: 18,
            color: "black",
            fontWeight: fontWeight || "600",
          }}
          variant={varianttype || null}
        >{label}
        </InputLabel>
      }
      <Select
        // multiple
        fullWidth
        size="small"
        error={isError || false}
        inputRef={ref || null}
        varianttype={varianttype || null}
        input={<OutlinedInput id={id} />}
        defaultValue={"[object Object]"}
        renderValue={(option) => option[renderValueKey] || selectLabel || "Select"}
        MenuProps={{
          ...MenuProps,
          PaperProps: {
            ...MenuProps?.PaperProps,
            style: {
              maxHeight: 250,
              ...MenuProps?.PaperProps?.style,
            },
          },
        }}
        {...rest}
        onOpen={(e) => {
          document.documentElement.style.overflow = "hidden";
          if (rest.onOpen) rest.onOpen(e);
        }}
        onClose={(e) => {
          document.documentElement.style.overflow = "";
          if (rest.onClose) rest.onClose(e);
        }}
      >
        <MenuItem
          disabled
          value="[object Object]"
          sx={{
            fontSize: "14px",
            fontFamily: "Poppins"
          }}
        >{selectLabel || "Select"}
        </MenuItem>
        {options?.map((option, i) => (
          <MenuItem
            sx={{
              color: "black",
              fontSize: "14px",
              fontFamily: "Poppins",
              textTransform: "capitalize"
            }}
            key={i}
            value={option}
            disableRipple
          >{option?.text || option?.name}
          </MenuItem>
        ))}
      </Select>
    </Fragment>
  )
}

export default SelectInput